<template>
  <h2 v-if="rubrik">{{ rubrik }}</h2>
  <RssFeed :rssFeed="rssFeed"></RssFeed>
  <div class="ursprungslank" v-if="ursprungsUrl && linkText">
    <a :href="ursprungsUrl">{{ linkText }} </a>
  </div>
</template>

<script>
import RssFeed from "./components/rssfeed.vue";
import rssservice from "../plugins/rssservice";

export default {
  name: "RssReader",
  props: {
    baseApiUrl: String,
    rssUrl: String,
    rubrik: String,
    maxObjekt: Number,
    ursprungsUrl: String,
    linkText: String,
    publiceradText: String,
    ansokSenastText: String,
    visaBaraAr: Boolean,
    sorteraPaPubdatumOchTitel: Boolean,
    arrowToLeft: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      rssFeed: null,
    };
  },
  components: {
    RssFeed,
  },
  created() {
    this.$.appContext.app.config.globalProperties = {
      $publiceradText: this.publiceradText,
      $ansokSenastText: this.ansokSenastText,
      $arrowToLeft: this.arrowToLeft,
    };
  },
  beforeMount() {
    this.getFeed();
  },
  methods: {
    getFeed: function () {
      rssservice
        .getFeed(
          this.baseApiUrl,
          this.rssUrl,
          this.visaBaraAr,
          this.sorteraPaPubdatumOchTitel,
          this.maxObjekt
        )
        .then((result) => {
          if (result && result.status == 200) {
            this.rssFeed = result.data;
          }
        });
    },
  },
};
</script>
